.row {
    box-sizing: border-box;
    cursor: grabbing;
    display: flex;
    min-height: 32px;
    overflow: hidden;
    width: 100%;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
}

.handle {
    width: 21px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    padding-left: 7px;
    color: var(--grey-lt);
    flex-grow: 0;
    background-color: var(--off-white-dk);
}

.handle > :first-child {
    height: 14px;
}

.content {
    cursor: inherit;
    display: flex;
    align-items: center;
    flex-grow: 1;
    background-color: var(--off-white);
    overflow: hidden;
    padding-left: 1px;
    min-width: 0;
}
